<template>
  <div class="margin-left-10" style="display: inline-block">
    <el-button size="small" type="primary" @click="isShowCreateDocumentForm = true" >
      Thêm tài liệu
    </el-button>
    <el-dialog :visible.sync="isShowCreateDocumentForm" width="70%">
      <div class="title_popup text-center"><FAIcon icon="fas fa-upload" /> Thêm tài liệu</div>

      <vue-dropzone
        ref="myVueDropzone"
        id="dropzone"
        :options="dropzoneOptions"
        @vdropzone-file-added="onFileAdded"
        @vdropzone-removed-file="onFileRemove"
        @vdropzone-mounted="onDropzoneMounted"
      ></vue-dropzone>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowCreateDocumentForm = false"><FAIcon icon="fas fa-times" /> Hủy bỏ</el-button>
        <el-button type="primary" @click="onSubmitCreateDocumentForm" :disabled="isUploading"
          ><FAIcon icon="fas fa-upload" />{{ isUploading ? " Đang tải..." : " Tải tài liệu" }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import { apiAppendFiles } from "@/services/group_management_service"
import { maxFileUpload } from "@/constants/DoITConstant"
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "AppendForm",
  props: ["groupId", "listDroppedFiles"],
  components: {
    vueDropzone: vue2Dropzone,
    FAIcon,
  },
  data: function () {
    return {
      isShowCreateDocumentForm: false,
      mode_page_check: "all",
      fileList: [],
      isUploading: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFilesize: 100,
        maxFiles: maxFileUpload.GroupDocumentCreate,
        addRemoveLinks: true,
        dictRemoveFile: "Loại bỏ",
        dictInvalidFileType: "Sai định dạng file",
        dictMaxFilesExceeded: "",
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>Kéo thả tài liệu hoặc bấm đây",
        acceptedFiles: ".doc, .docx, .pdf, .zip",
      },
      isFileExist: false,
      fileInProcess: 0,
    }
  },
  methods: {
    async onSubmitCreateDocumentForm() {
      if (this.$refs.myVueDropzone.getAcceptedFiles().length > 0) {
        this.isUploading = true
        const loading = this.$loading({
          lock: true,
          text: "Đang gửi tài liệu",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
          customClass: "l-spinner",
        })

        const acceptedFiles = this.$refs.myVueDropzone.getAcceptedFiles()
        let response_data = await apiAppendFiles(this.$refs.myVueDropzone.getAcceptedFiles(), this.groupId)
        //console.log(response_data)

        loading.close()

        if (response_data != null && response_data.status === "SUCCESS") {
          this.$message({
            message: response_data.description,
            type: "success",
          })
          this.$emit("success")
        } else {
          this.$message({
            message: "Có lỗi xảy ra",
            type: "error",
          })
        }

        this.isShowCreateDocumentForm = false
        this.$refs.myVueDropzone.removeAllFiles()
        this.isUploading = false
      } else {
        this.$message({
          message: "Tài liệu tải lên không đúng định dạng",
          type: "error",
        })
      }
    },
    onDropzoneMounted() {
      this.manuallyAddFile()
    },
    manuallyAddFile() {
      if (this.$refs.myVueDropzone) {
        for (let i = 0; i < this.listDroppedFiles.length; i++) {
          if (this.fileInProcess < maxFileUpload.GroupDocumentCreate) {
            let fileType = this.listDroppedFiles[i].name.split(".").slice(-1)[0]
            let isAccepted = fileType === "doc" || fileType === "docx" || fileType === "pdf" || fileType === "zip"
            this.listDroppedFiles[i].accepted = isAccepted
            this.$refs.myVueDropzone.manuallyAddFile(this.listDroppedFiles[i], "", null, null, {
              dontSubstractMaxFiles: false,
              addToFiles: true,
            })
          }
        }
        this.$emit("removeAllFileInDroppedList")
      }
    },
    onFileAdded(file) {
      this.fileInProcess += 1
      if (this.fileInProcess > maxFileUpload.DocumentCreate) {
        this.$message({
          message: "Số tài liệu đã vượt quá số lượng quy định (không quá 5)",
          type: "error",
        })
        this.$refs.myVueDropzone.removeFile(file)
      }
    },
    onFileRemove(file) {
      this.fileInProcess -= 1
    },
  },
  watch: {
    listDroppedFiles: function () {
      if (this.listDroppedFiles.length > 0) {
        this.isShowCreateDocumentForm = true
        if (this.$refs.myVueDropzone) {
          this.manuallyAddFile()
        }
      }
    },
    isShowCreateDocumentForm: function () {
      if (!this.isShowCreateDocumentForm) {
        this.$refs.myVueDropzone.removeAllFiles()
        this.fileInProcess = 0
      }
    },
  },
}
</script>

<style>
.checker-type-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.checker-type {
  width: 180px;
  margin-right: 10px;
}

.el-form-item__content .checker-type-container .el-input-group {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

label.el-form-item__label {
  font-size: 18px;
}

/*.dropzone .dz-preview .dz-remove:hover {*/
/*text-decoration: underline;*/
/*}*/
.vue-dropzone .dz-preview .dz-remove {
  border: none;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  margin: 0;
  background-color: rgba(108, 117, 125, 0.8);
  padding: 38% 10%;
}

.vue-dropzone .dz-preview .dz-error-mark {
  display: none;
}

.vue-dropzone .dz-preview.dz-error .dz-remove {
  padding-top: 70%;
  padding-bottom: 0;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}

.dz-progress {
  display: none;
}
</style>
